import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Typography, Box, IconButton
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  severity = "warning", // warning | danger | info
}) => {
  const colors = {
    warning: { icon: "#f59e0b", bg: "#fffbeb", btn: "#f59e0b", btnHover: "#d97706" },
    danger:  { icon: "#ef4444", bg: "#fef2f2", btn: "#ef4444", btnHover: "#dc2626" },
    info:    { icon: "#3b82f6", bg: "#eff6ff", btn: "#3b82f6", btnHover: "#2563eb" },
  };
  const c = colors[severity] || colors.warning;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth
      PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, pb: 0 }}>
        <Box sx={{
          width: 40, height: 40, borderRadius: "10px", backgroundColor: c.bg,
          display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        }}>
          <WarningAmberIcon sx={{ color: c.icon, fontSize: "22px" }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#111827", lineHeight: 1.3 }}>
            {title}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onCancel} sx={{ color: "#9CA3AF", mt: -0.5 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1.5 }}>
        <Typography sx={{ fontSize: "14px", color: "#6B7280", lineHeight: 1.6 }}>
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button onClick={onCancel} fullWidth
          sx={{
            border: "1.5px solid #D1D5DB", borderRadius: "10px", color: "#374151",
            textTransform: "none", fontSize: "14px",
            "&:hover": { backgroundColor: "#F9FAFB" },
          }}>
          {cancelLabel}
        </Button>
        <Button onClick={onConfirm} fullWidth variant="contained"
          sx={{
            borderRadius: "10px", backgroundColor: c.btn, color: "#fff",
            textTransform: "none", fontSize: "14px", fontWeight: 600,
            "&:hover": { backgroundColor: c.btnHover },
            boxShadow: "none",
          }}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
